import _styled from '@emotion/styled/base';
import { getFontSize, getNumericLetterSpacing } from '../../forms/shared/utils.js';
import { createFormElementWrapper, LeftElementWrapper as LeftElementWrapper$1, RightElementWrapper as RightElementWrapper$1, createFloatingLabel } from '../shared/composableStyles.js';

const InputWrapper = createFormElementWrapper();
const LeftElementWrapper = LeftElementWrapper$1;
const RightElementWrapper = RightElementWrapper$1;
const StyledInput = _styled("input", {
  target: "e1jjkunm0"
})("appearance:none;background-color:transparent;border:0;color:inherit;font-family:inherit;font-size:", ({
  inputSize
}) => getFontSize(inputSize), ";height:100%;width:100%;outline:none;font-variant-ligatures:none;z-index:1;position:relative;", ({
  numeric,
  inputSize
}) => numeric && `
    font-feature-settings: "tnum" on, "lnum" on;
    letter-spacing: ${getNumericLetterSpacing(inputSize)};
  `, " ::placeholder{color:", ({
  isFocused,
  hasValue,
  theme
}) => isFocused || hasValue ? theme.colorScheme.input.content.placeholder : 'transparent', ";opacity:1;}:disabled::placeholder{color:", ({
  isFocused,
  hasValue,
  theme
}) => isFocused || hasValue ? theme.colorScheme.content.disabled : 'transparent', ";}");
const FloatingLabel = createFloatingLabel();

export { FloatingLabel, InputWrapper, LeftElementWrapper, RightElementWrapper, StyledInput };
